export const noUserMenu = [
  {
    text: 'logInSession',
    link: '/login',
    openInDiferentPage: false
  },
  {
    text: 'createAccount',
    link: '/register',
    openInDiferentPage: false
  }
];
